import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useProductListingData from 'hooks/useProductListingData';
import ProductListingPageContext from 'data-hooks/context/ProductListingPageContext';
import { GET_CUSTOM_LIST_PRODUCT_DATA_V2 } from '@/graphql/queries';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import getCustomListSource from './algolia/getCustomListSource';
import hasCustomListAlgoliaCookie from './algolia/hasCustomListAlgoliaCookie';
import useAlgoliaCustomProductList from './algolia/useAlgoliaCustomProductList';
import CustomProductListUI from './CustomProductListUI';
const DEFAULT_PRODUCT_LIST = [];
const CustomProductListInner = t0 => {
  const $ = _c(38);
  const {
    config,
    isAdmin: t1
  } = t0;
  const isAdmin = t1 === undefined ? false : t1;
  const hasLoadingAllDataStartedRef = useRef(false);
  const [mode, setMode] = useState("legacy");
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMode(hasCustomListAlgoliaCookie() ? "algolia" : "legacy");
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  if ($[2] !== config) {
    t4 = config || {};
    $[2] = config;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    listStyle,
    toggleSourceType,
    sortByPopularity: t5,
    filterByStock: t6,
    listCardSize: t7
  } = t4;
  const sortByPopularity = t5 === undefined ? false : t5;
  const filterByStock = t6 === undefined ? false : t6;
  let t8;
  if ($[4] !== t7) {
    t8 = t7 === undefined ? {} : t7;
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const {
    cardSizeSelected: t9
  } = t8;
  const cardSizeSelected = t9 === undefined ? "medium" : t9;
  let t10;
  if ($[6] !== config) {
    t10 = getCustomListSource(config);
    $[6] = config;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const algoliaSource = t10;
  let t11;
  if ($[8] !== toggleSourceType) {
    t11 = toggleSourceType || {};
    $[8] = toggleSourceType;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const {
    productList: t12,
    customListSlug: t13,
    selected
  } = t11;
  const productList = t12 === undefined ? DEFAULT_PRODUCT_LIST : t12;
  const slug = t13 === undefined ? "" : t13;
  let t14;
  if ($[10] !== productList) {
    t14 = productList.map(_temp);
    $[10] = productList;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const productListWithSelectedOptions = t14;
  let t15;
  if ($[12] !== filterByStock || $[13] !== productListWithSelectedOptions || $[14] !== selected?.value || $[15] !== slug || $[16] !== sortByPopularity) {
    t15 = () => ({
      filterByStock,
      sortByPopularity,
      ...(selected?.value === "ProductsListInput" ? {
        productList: productListWithSelectedOptions
      } : {
        slug
      })
    });
    $[12] = filterByStock;
    $[13] = productListWithSelectedOptions;
    $[14] = selected?.value;
    $[15] = slug;
    $[16] = sortByPopularity;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  selected?.value;
  let t16;
  if ($[18] !== t15) {
    t16 = t15();
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const variables = t16;
  const t17 = mode === "algolia" || !slug && !productList?.length || isAdmin;
  let t18;
  if ($[20] !== t17 || $[21] !== variables) {
    t18 = {
      variables,
      skip: t17
    };
    $[20] = t17;
    $[21] = variables;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      isScrollTrackingDisabled: true
    };
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  const legacyData = useProductListingData(GET_CUSTOM_LIST_PRODUCT_DATA_V2, t18, t19);
  const t20 = algoliaSource?.listId;
  const t21 = mode !== "algolia" || !algoliaSource || isAdmin;
  let t22;
  if ($[24] !== filterByStock || $[25] !== t20 || $[26] !== t21) {
    t22 = {
      listId: t20,
      filterByStock,
      skip: t21
    };
    $[24] = filterByStock;
    $[25] = t20;
    $[26] = t21;
    $[27] = t22;
  } else {
    t22 = $[27];
  }
  const algoliaData = useAlgoliaCustomProductList(t22);
  const dataWithState = mode === "algolia" ? algoliaData : legacyData;
  const {
    loading,
    loadAllProducts
  } = dataWithState;
  let t23;
  let t24;
  if ($[28] !== loadAllProducts || $[29] !== loading) {
    t23 = () => {
      if (!loading && !hasLoadingAllDataStartedRef.current && loadAllProducts) {
        hasLoadingAllDataStartedRef.current = true;
        window.requestIdleCallback(async () => {
          loadAllProducts();
        });
      }
    };
    t24 = [loading, loadAllProducts];
    $[28] = loadAllProducts;
    $[29] = loading;
    $[30] = t23;
    $[31] = t24;
  } else {
    t23 = $[30];
    t24 = $[31];
  }
  useEffect(t23, t24);
  let t25;
  if ($[32] !== cardSizeSelected || $[33] !== listStyle) {
    t25 = <CustomProductListUI listStyle={listStyle} cardSize={cardSizeSelected} />;
    $[32] = cardSizeSelected;
    $[33] = listStyle;
    $[34] = t25;
  } else {
    t25 = $[34];
  }
  let t26;
  if ($[35] !== dataWithState || $[36] !== t25) {
    t26 = <ProductListingPageContext.Provider value={dataWithState}>{t25}</ProductListingPageContext.Provider>;
    $[35] = dataWithState;
    $[36] = t25;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  return t26;
};
const CustomProductList = props => {
  const $ = _c(8);
  if (props?.isAdmin) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <AdminPlaceholder className="!min-h-[470px]">Custom Product List Admin Placeholder</AdminPlaceholder>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (props?.config?.elementAttribute?.id) {
    const t0 = props?.config?.elementAttribute?.id;
    let t1;
    if ($[1] !== props) {
      t1 = <CustomProductListInner {...props} />;
      $[1] = props;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== t0 || $[4] !== t1) {
      t2 = <div id={t0}>{t1}</div>;
      $[3] = t0;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t0;
  if ($[6] !== props) {
    t0 = <CustomProductListInner {...props} />;
    $[6] = props;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
};
CustomProductList.propTypes = {
  isAdmin: PropTypes.bool,
  config: PropTypes.shape({
    elementAttribute: PropTypes.shape({
      id: PropTypes.string
    })
  })
};
CustomProductListInner.propTypes = {
  config: PropTypes.object,
  isAdmin: PropTypes.bool
};
export default CustomProductList;
function _temp(t0) {
  const {
    id,
    category,
    isInactive,
    selectedOptions
  } = t0;
  return {
    id,
    category,
    isInactive,
    selectedOptions: {
      optionId: selectedOptions?.optionId || null,
      optionType: selectedOptions?.optionType || "",
      optionValue: selectedOptions?.optionValue || "",
      optionValueId: selectedOptions?.optionValueId || null,
      optionValueSku: selectedOptions?.optionValueSku || ""
    }
  };
}